import React from 'react';

export const clinicalLensOptions = [
  ['cbt', 'CBT'], ['act', 'ACT'], ['dbt', 'DBT'], ['psychodynamic', 'Psychodynamic'],
  ['attachment', 'Attachment'], ['family_systems', 'Family Systems'],
  ['emotion_focused', 'Emotion-Focused'], ['motivational_interviewing', 'Motivational Interviewing'],
  ['trauma_informed', 'Trauma-Informed'], ['humanistic_person_centered', 'Humanistic / Person-Centered'],
  ['emdr', 'EMDR'], ['ifs', 'IFS'], ['integrative', 'Integrative'], ['other', 'Other'],
] as const;

interface ClinicalLensSelectorProps {
  title: string;
  helperText: string;
  values: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

export default function ClinicalLensSelector({
  title,
  helperText,
  values,
  onChange,
  disabled = false,
}: ClinicalLensSelectorProps) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{helperText}</p>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {clinicalLensOptions.map(([value, label]) => (
          <label key={value} className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 py-1">
            <input
              type="checkbox"
              checked={values.includes(value)}
              disabled={disabled}
              onChange={(event) => onChange(
                event.target.checked
                  ? [...values, value]
                  : values.filter((lens) => lens !== value),
              )}
              className="h-5 w-5"
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
}
